import { styled } from '@linaria/react';

export const Nav = styled.nav`
	width: 100%;
	display: flex;
	flex-flow: row wrap;
	align-items: flex-end !important;
	gap: 1rem;
	margin-bottom: 30px;

	&.stretch {
		> * {
			flex: 1;

			&.block-list-appender {
				flex: 0;

				> button {
					display: block;
				}
			}
		}
	}
`;

export const BodyWrapper = styled.div`
	flex: 1;
`;

export const Body = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	position: relative;
`;

export const EditorEndLine = styled.div`
	font-size: 0.7rem;
	position: relative;
	align-items: center;
	justify-content: center;
	opacity: 0.5;
	padding: 0.5rem 0;
	display: none;

	.has-child-selected & {
		display: flex;
	}

	&::after {
		content: '';
		position: absolute;
		width: 100%;
		height: 1px;
		background: black;
		bottom: 0;
		left: 0;
	}
`;

export const TabsItemWrapper = styled.div`
	height: 100%;
	width: 100%;
	display: flex;
	align-items: flex-end;

	&[data-open='true'],
	&[data-open='true'] > button:hover {
		--button-border-color: var( --text-color );
		--button-bottom-border-color: var( --bg-color );

		> button {
			font-weight: var( --font-weight-bold );
		}
	}
`;

export const VerticalTabsItemWrapper = styled( TabsItemWrapper )`
	align-items: stretch;
	padding-right: 1rem;

	button {
		max-width: 100% !important;
		bottom: -1px;
		right: -2px;
		border: 1px solid transparent;
		border-bottom: 1px solid var( --button-border-color );
		border-right: 2px solid white;
		padding-right: 0;
	}

	&[data-open='true'] {
		border-top: 1px solid var( --button-border-color );
		border-left: 1px solid var( --button-border-color );
		padding-right: 0;

		button {
			padding-right: 1rem;
		}
	}
`;

export const TabButton = styled.button`
	padding: 0.25rem;
	font-size: var( --font-size-hero-button );
	border-bottom: 3px solid var( --button-border-color );
	display: flex;
	justify-content: center;
	align-items: flex-end;
	background: transparent;
	width: 100%;
	position: relative;
	transition: border 0.25s ease;
	cursor: pointer;

	@media screen and ( max-width: 782px ) {
		text-align: left;
	}
`;

export const TabContent = styled.div`
	position: absolute;
	inset: 0;
	overflow: hidden;
	opacity: 0;
	transition: opacity 0.25s ease;
	padding: 1rem 0;
	pointer-events: none;
	animation: tabs-opacity 0.25s ease;

	&.active {
		position: relative;
		opacity: 1;
		pointer-events: auto;
		z-index: 1;
	}

	@keyframes tabs-opacity {
		0% {
			opacity: 0;
		}
		100% {
			opacity: 1;
		}
	}
`;

export const TabsWrapper = styled.div`
	--button-border-color: transparent;
	--button-bottom-border-color: transparent;

	display: flex;
	flex-direction: column;
	width: 100%;
	margin-bottom: 3rem !important;

	.splide__track {
		@media ( max-width: 768px ) {
			overflow: visible !important;
		}
	}
`;

export const VerticalTabsWrapper = styled( TabsWrapper )`
	--button-border-color: var( --text-color );

	flex-direction: row;

	${ Nav } {
		flex-direction: column;
		flex: 0 0 17rem;
		border: none;
		border-right: 1px solid var( --text-color );

		> * {
			width: 100%;
			flex: 0;
		}

		&.alignleft button {
			justify-content: flex-start;
			text-align: left;
		}

		&.aligncenter button {
			justify-content: center;
			text-align: center;
		}

		&.alignright button {
			justify-content: flex-end;
			text-align: right;
		}
	}

	${ Body } {
		.tab-content {
			padding: 0 0 0 2rem;
		}
	}

	@media screen and ( max-width: 768px ) {
		// MOBILE VERTICAL TABS AS ACCORDION
		&.is-vertical.mobile-horizontal {
			${ Nav } {
				display: none !important;
			}
		}

		&.is-vertical:not( .mobile-horizontal ) {
			display: block;

			${ Nav } {
				border-right: none;
			}

			${ TabButton } {
				position: relative;
				display: flex;
				align-items: center;
				justify-content: space-between !important;
				padding-bottom: 1rem;
				border-bottom: 0;

				.dhsv-button-icon {
					position: relative;
					display: inline-block;
					width: 1rem;
					height: 1rem;
					margin: 0 1rem;
					transform: rotate( 0deg );
					transition: all ease 0.25s;

					span {
						width: 1.5px;
						height: 1rem;
						position: absolute;
						top: 50%;
						left: 50%;
						background: currentColor;
						transform: translate( -50%, -50% );
						transition: all ease 0.25s;

						&:last-of-type {
							transform: translate( -50%, -50% ) rotate( 90deg );
						}
					}
				}
			}

			${ TabsItemWrapper } {
				flex-flow: column;
				border-bottom: 2px solid black;

				.tab-content-wrapper {
					height: 0;
					opacity: 0;
					transition: all 0.25s ease;
				}

				&[data-open='true'] {
					${ TabButton } {
						.dhsv-button-icon {
							transform: rotate( 180deg );

							span {
								transform: translate( -50%, -50% )
									rotate( 90deg );

								&:last-of-type {
									transform: translate( -50%, -50% )
										rotate( 90deg );
									opacity: 0;
								}
							}
						}
					}

					.tab-content-wrapper {
						height: auto;
						opacity: 1;
						pointer-events: auto;
					}
				}
			}

			${ TabContent } {
				position: relative;
				inset: unset;
				height: auto;
				padding-top: 0;
				opacity: 1;
				pointer-events: none;
				transition: all 0.25s ease;
			}
		}
	}
`;
